export default {"src":"/_next/static/media/Twins.1f8e572c.svg","height":60,"width":109};